import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6c800568"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "work-title"
  }, " 详细内容 ", -1);
});

var _hoisted_3 = {
  class: "tips"
};
var _hoisted_4 = {
  class: "submit_btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_Editor = _resolveComponent("Editor");

  var _component_UpLoadFile = _resolveComponent("UpLoadFile");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_form = _resolveComponent("el-form");

  var _directive_debounce = _resolveDirective("debounce");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "工作计划/总结",
    back: true
  }), _createVNode(_component_el_form, {
    ref: "ruleForms",
    "status-icon": "",
    "label-width": "120px",
    class: "demo-ruleForm",
    model: _ctx.ruleForm,
    rules: _ctx.rules
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form_item, {
        "label-width": "60px",
        label: "标题 ",
        prop: "title",
        class: "titinput"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.title = $event;
            }),
            placeholder: "请输入标题"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _hoisted_2, _createVNode(_component_Editor, {
        ref: "editorRef",
        puthtml: _ctx.editHtml,
        "onUpdate:puthtml": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.editHtml = $event;
        }),
        putText: _ctx.editText,
        "onUpdate:putText": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.editText = $event;
        }),
        onChange: _ctx.editchange
      }, null, 8, ["puthtml", "putText", "onChange"]), _createVNode(_component_UpLoadFile, {
        ref: "uploadRef",
        limit: 5,
        onFile: _ctx.filechange
      }, null, 8, ["onFile"]), _withDirectives(_createElementVNode("p", _hoisted_3, " * 内容或文件必须至少上传一个 ", 512), [[_vShow, _ctx.errorflag]]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.submitForm('ruleForms');
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.submitText), 1)];
        }),
        _: 1
      }, 512), [[_directive_debounce]])])])];
    }),
    _: 1
  }, 8, ["model", "rules"])], 64);
}